import baseService from './base';
import userService from './user';
import gameService from './game';
import duelService from './duel';

class ApiService {
  constructor() {
    this.User = userService;
    this.Game = gameService;
    this.Duel = duelService;
  }
}

export default new ApiService();
